import React from 'react'
import PropTypes from 'prop-types'

function JobsList({ list }) {
  return (
    <>
      {list.map(({ url, title, primaryLocation }, index) => (
        /* eslint-disable react/no-array-index-key */
        <ul className="jobs__dropdown-list" key={index}>
          <li className="jobs__dropdown-item ">
            <a className="jobs__dropdown-link" href={url} target="_blank" rel="noopener noreferrer">
              {title}
            </a>
            <span className="general-text">{primaryLocation}</span>
          </li>
        </ul>
      ))}
    </>
  )
}

JobsList.propTypes = {
  list: PropTypes.array.isRequired
}

export default JobsList
